import React, { useEffect, useState } from "react";
import { Grid, TextField, MenuItem, Button, FormControl, InputLabel, Select } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { format, subDays } from "date-fns";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const FilterBar = ({ filters, onFilterChange, onReload }) => {
    const [queues, setQueues] = useState([]);
    const [users, setUsers] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const { data: queueResponse } = await api.get("/queue");
                // Handle both array and object responses
                const queueList = Array.isArray(queueResponse) ? queueResponse : (queueResponse.queues || []);
                setQueues(queueList);

                const { data: userResponse } = await api.get("/users");
                // Handle both array and object responses
                const userList = Array.isArray(userResponse) ? userResponse : (userResponse.users || []);
                setUsers(userList);

                console.log("Queues loaded:", queueList);
                console.log("Users loaded:", userList);
            } catch (err) {
                console.error("Error loading filters:", err);
                toastError(err);
            }
        })();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        onFilterChange({ ...filters, [name]: value });
    };

    return (
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={3}>
                <TextField
                    fullWidth
                    label="Data Inicial"
                    type="date"
                    name="dateFrom"
                    value={filters.dateFrom}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                />
            </Grid>
            <Grid item xs={12} sm={3}>
                <TextField
                    fullWidth
                    label="Data Final"
                    type="date"
                    name="dateTo"
                    value={filters.dateTo}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                />
            </Grid>

            {/* Queue Filter (Multi-select usually requires standard Select or Autocomplete) */}
            {/* For simplicity we use standard Select single or simple implementation first */}
            <Grid item xs={12} sm={2}>
                <FormControl fullWidth>
                    <InputLabel>Fila</InputLabel>
                    <Select
                        name="queueIds"
                        value={filters.queueIds}
                        onChange={handleChange}
                    // multiple // Implement logic for multiple if backend supports array
                    >
                        <MenuItem value="">Todas</MenuItem>
                        {Array.isArray(queues) && queues.map((q) => (
                            <MenuItem key={q.id} value={q.id}>{q.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={12} sm={2}>
                <FormControl fullWidth>
                    <InputLabel>Atendente</InputLabel>
                    <Select
                        name="userIds"
                        value={filters.userIds}
                        onChange={handleChange}
                    >
                        <MenuItem value="">Todos</MenuItem>
                        {Array.isArray(users) && users.map((u) => (
                            <MenuItem key={u.id} value={u.id}>{u.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={12} sm={2}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={onReload}
                >
                    Atualizar
                </Button>
            </Grid>
        </Grid>
    );
};

export default FilterBar;
